import { useMutation } from '@tanstack/react-query';
import { downloadAttachmentById } from '../Services/ProcessedTimesheetService';

const useDownloadProcessedTimesheetAttachment = (options) =>
    useMutation(downloadAttachmentById, options);

export default useDownloadProcessedTimesheetAttachment;
